/**
 * R2-Phase-3 — global 4-digit run-number helpers.
 *
 * Mirrors the backend `services.run_number_service` helpers so the UI can
 * format / parse without an extra round-trip.
 */

export function formatRunNumber(n) {
  if (n == null) return "—";
  const x = Number(n);
  if (!Number.isFinite(x) || x < 0) return "—";
  if (x < 10000) return String(x).padStart(4, "0");
  return String(x);
}

/** "#42", "42", "0042", "  #0123  " → 42.  Anything else → null. */
export function parseRunNumberQuery(q) {
  if (q == null) return null;
  const s = String(q).trim();
  if (!s || s.length > 12) return null;
  const m = s.match(/^#?\s*0*(\d{1,9})$/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? n : null;
}

/**
 * R3-Phase-1 (2026-05-26) — canonical "#0041" reference token.
 *
 * Returns the run number formatted as `#NNNN` as a SINGLE STRING so
 * `#` and the digits stay in the same text node.  This is immune to
 * the platform's "Visual Edits" framework which wraps every JSX
 * `{expression}` in a `<span style="display:contents">` — code like
 * `#{formatRunNumber(n)}` puts `#` in the parent text node and `0041`
 * inside the wrapper, so a tester reading the inner span's
 * textContent sees only `0041`.
 *
 * Use this helper everywhere the user-facing run number appears:
 *   <td>{runRef(r.run_number)}</td>
 *   <span>Run {runRef(run.run_number)}</span>
 *   <span>{runRef(metadata.run_number)}</span>
 */
export function runRef(n) {
  return `#${formatRunNumber(n)}`;
}

/** "Run #0042" — convenience for chips, headers, OG tags. */
export function runLabel(n) {
  return `Run ${runRef(n)}`;
}
